// extracted by mini-css-extract-plugin
export var formContainer = "_ea-0";
export var message = "_ea-1";